'use client';
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import type { CampaignFormData } from './CampaignBuilderClient';

const brandCategories = ['FMCG', 'Tech', 'Telecom', 'Fashion', 'Beauty', 'Food & Beverage', 'Automotive', 'Finance', 'Healthcare', 'Education', 'Real Estate', 'Autre'];

interface Props { form: UseFormReturn<CampaignFormData>; }

export default function StepBrandInfo({ form }: Props) {
  const { register, formState: { errors } } = form;

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-700 text-foreground mb-1">Informations de la marque</h2>
        <p className="text-sm text-muted-foreground">Renseignez les informations de base sur votre marque et votre contact.</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-600 text-foreground mb-1">
            Nom de la marque <span className="text-negative">*</span>
          </label>
          <p className="text-xs text-muted-foreground mb-2">Le nom commercial de votre marque ou produit</p>
          <input
            {...register('brandName', { required: 'Le nom de la marque est requis' })}
            className="w-full bg-input border border-border rounded-lg px-4 py-2.5 text-sm text-foreground placeholder-muted-foreground outline-none focus:border-primary transition-colors"
            placeholder="Ex: Samsung Algérie"
          />
          {errors.brandName && <p className="text-xs text-negative mt-1">{errors.brandName.message}</p>}
        </div>

        <div>
          <label className="block text-sm font-600 text-foreground mb-1">
            Secteur d'activité <span className="text-negative">*</span>
          </label>
          <p className="text-xs text-muted-foreground mb-2">Catégorie principale de votre activité</p>
          <select
            {...register('brandCategory', { required: 'Le secteur est requis' })}
            className="w-full bg-input border border-border rounded-lg px-4 py-2.5 text-sm text-foreground outline-none focus:border-primary transition-colors"
          >
            <option value="">Choisir un secteur</option>
            {brandCategories.map(cat => (
              <option key={`bc-${cat}`} value={cat}>{cat}</option>
            ))}
          </select>
          {errors.brandCategory && <p className="text-xs text-negative mt-1">{errors.brandCategory.message}</p>}
        </div>

        <div>
          <label className="block text-sm font-600 text-foreground mb-1">
            Nom du contact <span className="text-negative">*</span>
          </label>
          <p className="text-xs text-muted-foreground mb-2">Responsable marketing ou chef de projet</p>
          <input
            {...register('contactName', { required: 'Le nom du contact est requis' })}
            className="w-full bg-input border border-border rounded-lg px-4 py-2.5 text-sm text-foreground placeholder-muted-foreground outline-none focus:border-primary transition-colors"
            placeholder="Ex: Tarek Ziani"
          />
          {errors.contactName && <p className="text-xs text-negative mt-1">{errors.contactName.message}</p>}
        </div>

        <div>
          <label className="block text-sm font-600 text-foreground mb-1">
            Email professionnel <span className="text-negative">*</span>
          </label>
          <p className="text-xs text-muted-foreground mb-2">Adresse email pour le suivi de la campagne</p>
          <input
            type="email"
            {...register('contactEmail', {
              required: 'L\'email est requis',
              pattern: { value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: 'Email invalide' },
            })}
            className="w-full bg-input border border-border rounded-lg px-4 py-2.5 text-sm text-foreground placeholder-muted-foreground outline-none focus:border-primary transition-colors"
            placeholder="Ex: t.ziani@samsung.com"
          />
          {errors.contactEmail && <p className="text-xs text-negative mt-1">{errors.contactEmail.message}</p>}
        </div>
      </div>
    </div>
  );
}